<template>
  <div v-if="panier">
    <div v-if="!panierUpdating && panier">
      <template v-if="panier.produits">
        <table cellspacing="0">
          <tr v-for="detail in panier.produits.filter((p) => p.prix >= 0)" :key="detail.id">
            <td class="description px-3 py-2 d-flex align-center">
              <span>{{ detail.description }}</span>
              <span class="primary--text ml-3 caption" v-if="detail.prorata" disabled>({{ detail.prorata }} d'année)</span>
              <span class="secondary--text ml-3 caption" v-if="detail.quantite">x{{ detail.quantite }}</span>
            </td>
            <td class="montant text-right px-3 py-2">{{ detail.prix | money }}</td>
          </tr>

          <tr v-for="detail in panier.produits.filter((p) => p.prix < 0)" :key="detail.id" class="error--text">
            <td class="description px-3 py-2 d-flex align-center">
              <span>{{ detail.description }}</span>
              <span class="primary--text ml-3 caption" v-if="detail.prorata" disabled>({{ detail.prorata }} d'année)</span>
              <span class="ml-3 caption" v-if="detail.quantite">x{{ detail.quantite }}</span>
            </td>
            <td class="montant text-right px-3 py-2">{{ detail.prix | money }}</td>
          </tr>

          <tr>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td class="description px-3 py-2">{{ panier.taxes.description }}</td>
            <td class="montant text-right px-3 py-2">{{ panier.taxes.prix | money }}</td>
          </tr>

          <tr>
            <td colspan="2"></td>
          </tr>
          <tr class="font-weight-bold">
            <td class="description px-3 py-2">{{ panier.total.description }}</td>
            <td class="montant text-right px-3 py-2">{{ panier.total.prix | money }}</td>
          </tr>
          <tr>
            <td colspan="2"></td>
          </tr>
        </table>
      </template>
      <template v-else>
        <span class="caption">Panier vide</span>
      </template>
    </div>
    <div v-if="panierUpdating">
      <v-skeleton-loader v-for="i in 3" :key="i" type="text" :width="Math.floor(Math.random() * 100) + 100"></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters(["panier", "panierUpdating"])
  }
}
</script>

<style scoped>
td {
  border-bottom: 1px solid #ccc;
}
</style>